// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import StatusLine from "./status-line-APP_CLIENT/StatusLine-APP_CLIENT";

export default StatusLine;
